import React from 'react'
import { Col, Form, FormGroup, Input, Label } from 'reactstrap'

const FiltroVacacionesSolicitadas = (props) => {

    
    return (
        <>
            <Form>
                <FormGroup row>
                    <Col>
                        <Label>Estado</Label>
                        <Input type='select' onChange={(e) => props.setEstado(e.target.value)}>
                            <option value={"PENDIENTE"}>Pendiente</option>
                            <option value={"APROBADA"}>Aprovado</option>
                            <option value={"RECHAZADO"}> Denegado</option>
                        </Input>
                    </Col>

                    <Col>
                        <Label>Fecha desde</Label>
                        <Input type='date' onChange={(e) => props.setDesde(e.target.value)}></Input>
                    </Col>

                    <Col>
                        <Label>Fecha hasta</Label>
                        <Input type='date' onChange={(e) => props.setHasta(e.target.value)}></Input>
                    </Col>
                </FormGroup>

            </Form>
        </>
    )
}

export default FiltroVacacionesSolicitadas